module.exports = __webpack_public_path__ + "static/media/avianex.f9bed15d.svg";